import { DatePickerInputPart } from '../date-picker-input-part/date-picker-input-part.component';

export const addLeadingZeros = (value: number | undefined, length: number): number | undefined => {
  return value === undefined || isNaN(value) ? undefined : ((`${value}`.padStart(length, '0') as unknown) as number);
};

export const constrainValue = (value: number, min: number, max: number): number | undefined => {
  if (isNaN(value)) {
    return undefined;
  }
  if (value < min) {
    return min;
  }
  if (value > max) {
    return max;
  }
  return value;
};

const getSiblingInput = (
  element: DatePickerInputPart | HTMLSpanElement,
  siblingKey: 'previousElementSibling' | 'nextElementSibling'
): DatePickerInputPart | undefined => {
  const sibling = element[siblingKey];

  if (sibling === null) {
    return undefined;
  }

  if (sibling instanceof DatePickerInputPart) {
    return sibling;
  }

  if (sibling instanceof HTMLSpanElement) {
    return getSiblingInput(sibling, siblingKey);
  }

  return undefined;
};

export const getPreviousInput = (element: DatePickerInputPart): DatePickerInputPart | undefined =>
  getSiblingInput(element, 'previousElementSibling');
export const getNextInput = (element: DatePickerInputPart): DatePickerInputPart | undefined =>
  getSiblingInput(element, 'nextElementSibling');
